import { isNumber, isString } from 'lodash'

export const AVACY_EVENT_TYPE = 'avacy_consent'

export interface AvacyEvent {
  type: string
  detail: {
    customVendorsWithConsent: {
      name: string
      id: number | string
    }[]
    iabVendorsWithConsent: {
      name: string
      id: number | string
    }[]
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isAvacyEvent = (event: any): event is AvacyEvent =>
  event instanceof Object &&
  isString(event.type) &&
  !!event.detail &&
  event.detail instanceof Object &&
  Array.isArray(event.detail.customVendorsWithConsent) &&
  (!event.detail.customVendorsWithConsent.length ||
    (isString(event.detail.customVendorsWithConsent[0].name) &&
      (isNumber(event.detail.customVendorsWithConsent[0].id) ||
        isString(event.detail.customVendorsWithConsent[0].id)))) &&
  Array.isArray(event.detail.iabVendorsWithConsent) &&
  (!event.detail.iabVendorsWithConsent.length ||
    (isString(event.detail.iabVendorsWithConsent[0].name) &&
      (isNumber(event.detail.iabVendorsWithConsent[0].id) || isString(event.detail.iabVendorsWithConsent[0].id))))
